/** Cancel a running subagent job. Jobs router is mounted at /jobs (nginx
 *  passes the path through unrewritten — /v1/jobs 404s). Errors are
 *  swallowed; the next subagent_event / status update reconciles the UI. */
export async function cancelSubagent(jobId: string): Promise<void> {
  try {
    await fetch(`/jobs/${jobId}/cancel`, { method: "POST", credentials: "include" });
  } catch (_) {
    /* swallow */
  }
}
